/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { createReducer } from '@trello/redux';

export interface ShortLinkMapState {
  [id: string]: string;
}

const initialState: ShortLinkMapState = {};

export default createReducer(initialState, {});
